<div class="hero-card" *ngIf="storyReady">
    <mat-card class="mat-card-in-progress-card">
        <mat-card-title>{{ 'inProgressStory.text1' | translate }}</mat-card-title>
        <div class="mb-8 in-progress-icon-container">
            <img src="./assets/imgs/inProgressQuizIcon.jpg" class="in-progress-icons"/>
        </div>
        <mat-card-content>
            <ul class="in-progress-container-items-list">
                <li>{{ 'inProgressStory.text2' | translate: { value: inProgressStory.storybookName } }}</li>
                <li>{{ 'inProgressStory.text3' | translate: { value: inProgressStory.stoppedOnPageNumber } }}</li>
                <li> </li>
                <li><button (click)="goToStory()" class="btn btn-primary">{{ 'inProgressStory.text4' | translate }}</button></li>
            </ul>
          </mat-card-content>


    </mat-card>
</div>
